// extracted by mini-css-extract-plugin
export default {"input":"input_input__a9IE0","label":"input_label__vwV4P","description":"input_description__Hjlu5"};